import {CAP_LEVELS} from "../domain/CapLevels";

export const getContentCapLevelName = (capLevelKey) => {
    const capLevel = CAP_LEVELS.filter(obj => obj.key === capLevelKey)[0];
    return capLevel?.name;
}

export const getContentCapLevelKey = (capLevelName) => {
    const capLevel = CAP_LEVELS.filter(obj => obj.name === capLevelName)[0];
    return capLevel?.key;
}

export const getDefaultCapLevel = () => CAP_LEVELS[0].key;
